const Footer = ({
  aboutUs,
  landingPrimaryColor,
  landingSecondaryColor,
  privacyPolicy,
  disclaimers,
  termsAndConditions,
  refundPolicy,
}) => {
  return (
    <footer
      id="footer"
      class="footer"
      style={{ fontFamily: 'Poppins, sans-serif' }}
    >
      <div class="footer-top" style={{ background: landingPrimaryColor }}>
        <div class="container">
          <div class="row">
            <div class="col-lg-5 col-md-6 col-12">
              <div class="single-footer">
                <h2>About Us</h2>
                <p>{aboutUs}</p>
              </div>
            </div>

            <div class="col-lg-4 col-md-6 col-12">
              <div class="single-footer f-link">
                <h2>Quick Links</h2>
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-12">
                    <ul>
                      {privacyPolicy && (
                        <li>
                          <a href="/privacy-policy">
                            <i class="fa fa-caret-right" aria-hidden="true"></i>
                            Privacy Policy
                          </a>
                        </li>
                      )}
                      {disclaimers && (
                        <li>
                          <a href="/disclaimers">
                            <i class="fa fa-caret-right" aria-hidden="true"></i>
                            Disclaimers
                          </a>
                        </li>
                      )}
                      {termsAndConditions && (
                        <li>
                          <a href="/terms-and-conditions">
                            <i class="fa fa-caret-right" aria-hidden="true"></i>
                            Terms & Conditons
                          </a>
                        </li>
                      )}
                      {refundPolicy && (
                        <li>
                          <a href="/refund-policy">
                            <i class="fa fa-caret-right" aria-hidden="true"></i>
                            Refund Policy
                          </a>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-12">
              <div class="single-footer">
                <h2>Support Hours</h2>
                <ul class="time-sidual">
                  <li class="day">
                    Monday - Saturday <span>9 AM - 6 PM</span>
                  </li>
                  <li class="day">
                    Sunday <span>9 AM - 2 PM</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="copyright" style={{ background: landingSecondaryColor }}>
        <div class="container">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-12">
              <div class="copyright-content">
                <p>
                  &copy; Copyrights {new Date().getFullYear()}. All Rights
                  Reserved.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
